import * as ActionTypes from './actionTypes';

export const setMissedOperatorMessages = (payload: any) => {
    return {
        type: ActionTypes.SET_MISSED_OPERATOR_MESSAGES,
        payload,
    };
};


// WEBPACK FOOTER //
// ./modules/live-chat-foundation-missed-count/actions/actions.ts